import React, { Component } from 'react';
import { branch } from 'baobab-react/higher-order';
import ButtonLink from '../../common/TrackedButtonLink';
import CmsContentWrapper from "../../common/CmsContentWrapper";
import VideoPlayer from "../VideoPlayer";
import PropTypes from 'prop-types';

class VideoLeftTextRight extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }

    render() {
        const {
            titleText,
            descriptionText,
            buttonText = '',
            buttonTo = '',
            videoUrl = null,
            poster = false,
            initial = 0
        } = this.props.data;

        return (
            <div className="product-feature product-feature-reverse-on-mobile-only bg-white py-5" style={{justifyContent: 'center'}}>
                <div className="feature-image feature-image-video">
                    {videoUrl && <VideoPlayer url={videoUrl} text={titleText} poster={poster} initial={initial} />}
                </div>
                <div className="feature-content mb-4">
                    <h2 className="feature-title feature-title--large">{titleText}</h2>
                    <CmsContentWrapper html={descriptionText} />
                    {buttonText &&
                        <ButtonLink className="btn-primary" to={buttonTo}>{buttonText}</ButtonLink>
                    }
                </div>
            </div>
        );
    }
}

VideoLeftTextRight.propTypes = {
    data: PropTypes.shape({
        videoUrl: PropTypes.string.isRequired,
        titleText: PropTypes.string.isRequired,
        descriptionText: PropTypes.string.isRequired,
        buttonText: PropTypes.string,
        buttonTo: PropTypes.string,
        poster: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
        initial: PropTypes.number,
    }).isRequired,
};

export default branch({
}, VideoLeftTextRight);



// WEBPACK FOOTER //
// ./src/pages/components/page/VideoLeftTextRight.js